import apiClient from "@/api/client";
import type { HelperInstance, HelperLogEntry, HelperOverview, HelperSettings } from "./types";
import { downloadBlob } from "@/utils/download";

// apiClient ma już baseURL "/api/v1" — tu tylko reszta ścieżki.
const BASE = "/power-projects";

async function unwrap<T>(p: Promise<{ data: { data: T } }>): Promise<T> {
  const r = await p;
  return r.data.data;
}

/** Stanowiska z wtyczką + metadane paczki + stan kolejki ksiąg. */
export const getHelperOverview = () =>
  unwrap<HelperOverview>(apiClient.get(`${BASE}/browser-helpers/`));

/** Nazwa stanowiska, zapisywanie logów i ustawienia narzucone wtyczce. */
export const updateHelperInstance = (
  id: string,
  patch: { label?: string; log_verbose?: boolean; desired?: Partial<HelperSettings> },
) =>
  unwrap<Pick<HelperInstance, "id" | "label" | "log_verbose"> & { desired: Partial<HelperSettings> }>(
    apiClient.patch(`${BASE}/browser-helpers/${id}/`, patch),
  );

/** Zdejmij stanowisko z listy (np. po przeinstalowaniu wtyczki). */
export const deleteHelperInstance = (id: string) =>
  unwrap<{ deleted: boolean }>(apiClient.delete(`${BASE}/browser-helpers/${id}/`));

/** Dziennik prób pobrania (opcjonalnie razem z krokami diagnostycznymi). */
export const getHelperLogs = (params: { installId?: string; verbose?: boolean; limit?: number }) =>
  unwrap<{ items: HelperLogEntry[]; stats: Record<string, unknown> }>(
    apiClient.get(`${BASE}/parcel-kw/autofetch-log/`, {
      params: {
        install_id: params.installId || undefined,
        verbose: params.verbose ? 1 : undefined,
        limit: params.limit ?? 100,
      },
    }),
  );

/** Pobierz paczkę wtyczki. Zwykły link tu nie zadziała — endpoint jest za tokenem
 *  (developer lub flaga dostępu do wtyczek), więc plik bierzemy XHR-em i zapisujemy
 *  z nagłówka. */
export async function downloadHelperPackage(flavor: "chrome" | "firefox") {
  const resp = await apiClient.get(`${BASE}/browser-helpers/package/`, {
    params: { flavor },
    responseType: "blob",
  });
  const cd = (resp.headers?.["content-disposition"] as string) || "";
  const match = /filename="?([^"]+)"?/.exec(cd);
  downloadBlob(resp.data as Blob, match ? match[1] : `elgw5-kw-helper-${flavor}.zip`);
}
